module.exports = __webpack_public_path__ + "img/video_info.fbafc05a.jpg";